import { useEffect } from 'react';
import heroBg from '@/assets/hero-background.jpg';
import crystal1 from '@/assets/floating-crystal-1.png';
import mandala2 from '@/assets/floating-mandala-2.png';
import orb3 from '@/assets/floating-orb-3.png';

// Performance optimization component
const PerformanceOptimizer = () => {
  useEffect(() => {
    // Web Vitals monitoring - only in production and if web-vitals is available
    if (process.env.NODE_ENV === 'production') {
      import('web-vitals').then(({ onCLS, onFCP, onLCP, onTTFB, onINP }) => {
        onCLS(console.log);
        onFCP(console.log);
        onLCP(console.log);
        onTTFB(console.log);
        onINP(console.log);
      }).catch(() => {
        // Silently fail if web-vitals is not available
      });
    }

    // Resource hints for future navigation - using bundled assets
    const prefetchLinks = [
      heroBg,
      crystal1,
      mandala2,
      orb3,
      '/lovable-uploads/39c21a26-18ce-4bd9-b27c-9b4e2671dade.png', // Logo principal
      '/lovable-uploads/b922e941-ba23-47fb-be9f-50db1c876345.png', // Logo header
    ];

    prefetchLinks.forEach(href => {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      document.head.appendChild(link);
    });

    return () => {
      // Cleanup prefetch links
      prefetchLinks.forEach(href => {
        const link = document.querySelector(`link[href="${href}"]`);
        if (link) {
          document.head.removeChild(link);
        }
      });
    };
  }, []);

  return null;
};

export default PerformanceOptimizer;